var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['section-head', { left: _vm.align === 'left' }]},[(_vm.eyebrow)?_c('div',{staticClass:"eyebrow"},[_vm._v(_vm._s(_vm.eyebrow))]):_vm._e(),_c('h2',{staticClass:"section-title"},[_vm._t("default")],2),(_vm.copy)?_c('p',{staticClass:"section-copy"},[_vm._v(_vm._s(_vm.copy))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }